import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
// Components
import FullButton from "../Buttons/FullButton";
import products from "../../data/products";
// Assets
import LogoImg from "../../assets/svg/Logo2";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

function FooterNavLink({ to, children }) {
  return (
    <RouterLink className="pointer animate" to={to}>
      {children}
    </RouterLink>
  );
}

export default function Footer() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container" style={{ paddingTop: "50px" }}>
          <CtaBand>
            <CtaInner className="flexSpaceCenter">
              <div>
                <h2 className="whiteColor font30 extraBold">Ready to upgrade your lab?</h2>
                <p className="whiteColor font15">Talk to our team about the right diagnostic solution for you.</p>
              </div>
              <CtaBtnWrapper>
                <FooterNavLink to="/contact">
                  <FullButton title="Contact Us" />
                </FooterNavLink>
              </CtaBtnWrapper>
            </CtaInner>
          </CtaBand>
          <Columns>
            <Column>
              <FooterNavLink to="/">
                <LogoImg />
              </FooterNavLink>
              <ColumnText className="whiteColor font13">
                Finechek (A) Systems supplies scientific instruments, laboratory equipment,
                reagents and consumables to laboratories across Africa, delivering reliable,
                lab-quality diagnostic solutions from sample to result.
              </ColumnText>
            </Column>
            {/* <Column>
              <ColumnTitle className="whiteColor font15 extraBold">Our Products</ColumnTitle>
              <LinkList>
                {products.map((product) => (
                  <li key={product.slug}>
                    <RouterLink className="pointer animate" to={`/products/${product.slug}`}>
                      <span className="whiteColor font13">{product.name}</span>
                    </RouterLink>
                  </li>
                ))}
              </LinkList>
            </Column> */}
            <Column>
              <ColumnTitle className="whiteColor font15 extraBold">Quick Links</ColumnTitle>
              <LinkList>
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <FooterNavLink to={link.to}>
                      <span className="whiteColor font13">{link.label}</span>
                    </FooterNavLink>
                  </li>
                ))}
              </LinkList>
            </Column>
            <Column>
              <ColumnTitle className="whiteColor font15 extraBold">Contact Us</ColumnTitle>
              <ContactList>
                <li className="whiteColor font13">
                  Human House, Ngara West Road<br />
                  Nairobi, Kenya
                </li>
                <li>
                  <a className="whiteColor font13" href="tel:+254722822595">
                    0722 822 595
                  </a>
                </li>
                <li>
                  <a className="whiteColor font13" href="mailto:info@finechek.com">
                    info@finechek.com
                  </a>
                </li>
              </ContactList>
            </Column>
          </Columns>
          <BottomBar className="textCenter">
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="whiteColor font13">Finechek</span> made with mad love by ICT team.
            </StyleP>
          </BottomBar>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const CtaBand = styled.div`
  border-radius: 16px;
  background-color: rgb(119, 31, 115);
`;
const CtaInner = styled.div`
  padding: 35px 40px;
  gap: 20px;
  p {
    margin-top: 8px;
    opacity: 0.9;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    text-align: center;
  }
`;
const CtaBtnWrapper = styled.div`
  flex-shrink: 0;
  a {
    display: inline-block;
    min-width: 180px;
  }
  button {
    background-color: #fff !important;
    border-color: #fff !important;
    color: rgb(119, 31, 115) !important;
  }
  button:hover {
    background-color: rgba(255, 255, 255, 0.9) !important;
    color: rgb(119, 31, 115) !important;
  }
`;
const Columns = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1.2fr 1fr 1.3fr;
  gap: 40px;
  padding: 50px 0 30px 0;
  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
`;
const Column = styled.div`
  a {
    text-decoration: none;
  }
`;
const ColumnTitle = styled.h4`
  margin-bottom: 20px;
`;
const ColumnText = styled.p`
  margin-top: 20px;
  max-width: 320px;
  opacity: 0.8;
  @media (max-width: 700px) {
    margin: 20px auto 0 auto;
  }
`;
const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    margin-bottom: 12px;
  }
  a {
    opacity: 0.8;
  }
  a:hover {
    opacity: 1;
  }
`;
const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    margin-bottom: 12px;
    line-height: 1.6;
  }
  a {
    opacity: 0.8;
  }
  a:hover {
    opacity: 1;
  }
`;
const BottomBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
`;
const StyleP = styled.p`
  margin: 0;
`;
